<div>
  <h3 class="setup-info">According to your connection type, follow next Setup Steps to set up your platform:</h3>

  <div class="setup-wrapper">
    @if (isWithServiceTypeActive()) {
    <h4 class="setup-title">SMPP Integration With Routing Parameters</h4>

    <div class="setup-text-wrapper">
      <ol class="setup-list">
        <li><strong>Whitelist TelQ's IP 52.29.63.229</strong> on your firewall.</li>
        <li><strong>Create one SMPP account</strong> in your system for TelQ (the single bind).</li>
        <li>
          <strong>Add routing</strong> on your side so that when your platform receives the test with the
          assigned service_type, it forwards it to the corresponding supplier.<br />
          <strong>Always route via your platform.</strong>
          Direct TelQ → vendor routing isn't allowed as it can expose tests and lead to test-number
          whitelisting.
        </li>
      </ol>
    </div>

    <img src="/img/smpp_integration_service_type_mini.png" alt="SMPP Integration With Routing Parameters" class="w-100 setup-image" />

    } @else {

    <h4 class="setup-title">SMPP Integration Without Routing Parameters</h4>

    <div class="setup-text-wrapper">
      <ol class="setup-list">
        <li><strong>Whitelist TelQ's IP 52.29.63.229</strong> on your firewall.</li>
        <li>
          <strong>Create one SMPP account per supplier</strong> on your side (e.g., “TelQ-Supplier-A”,
          “TelQ-Supplier-B”…).
        </li>
        <li>
          <strong>In your platform route each account</strong> to its specific supplier inside your platform.
        </li>
      </ol>
    </div>

    <img src="/img/smpp_integration_without_service_type_mini.png" alt="SMPP Integration Without Routing Parameters" class="w-100 setup-image" />

    }
  </div>
</div>
